import React from "react";
import { Formik, Field, Form } from "formik";
import MultiSelect from "form-controls/MultiSelect";
import Switch from "form-controls/Switch";
import Button from "Button";
import "./BookingFilterForm.css";

const uniqueValues = arr =>
  arr.filter(
    ({ value }, idx) =>
      arr.findIndex(({ value: innerValue }) => innerValue === value) === idx
  );

const alphaCompare = (a, b) => {
  if (a.label === b.label) {
    return 0;
  }

  return a.label > b.label ? 1 : -1;
};

const directionOptions = [
  { value: "inbound", label: "Inbound" },
  { value: "outbound", label: "Outbound" },
  { value: "internal", label: "Internal" }
];

const statusOptions = [
  { value: "new", label: "New" },
  { value: "staged", label: "Staged" },
  { value: "staged_arrived", label: "Staged Arrived" },
  { value: "ready_for_driver", label: "Ready For Driver" },
  { value: "completed", label: "Completed" },
  { value: "proposed", label: "Proposed" }
];

const haulierOptions = bookings =>
  uniqueValues(
    bookings
      .filter(b => b.haulier)
      .map(b => ({
        value: b.haulier.id,
        label: b.haulier.name
      }))
  ).sort(alphaCompare);

const sendingSiteOptions = bookings =>
  uniqueValues(
    bookings
      .filter(b => b.sendingSite)
      .map(b => ({
        value: b.sendingSite.id,
        label: b.sendingSite.name
      }))
  ).sort(alphaCompare);

const receivingSiteOptions = bookings =>
  uniqueValues(
    bookings
      .filter(b => b.receivingSite)
      .map(b => ({
        value: b.receivingSite.id,
        label: b.receivingSite.name
      }))
  ).sort(alphaCompare);

const loadTypeOptions = bookings =>
  uniqueValues(
    bookings
      .filter(b => b.loadType)
      .map(b => ({
        value: b.loadType,
        label: b.loadType
      }))
  ).sort(alphaCompare);

const trailerTypeOptions = bookings =>
  uniqueValues(
    bookings
      .filter(b => b.trailerType)
      .map(b => ({
        value: b.trailerType.id,
        label: b.trailerType.name
      }))
  ).sort(alphaCompare);

export default function BookingFilterForm({
  appliedFilters,
  bookings,
  onSubmit,
  onReset
}) {
  const initialValues = {
    includeInternal: false,
    direction: [],
    status: [],
    haulier: [],
    sendingSite: [],
    receivingSite: [],
    loadType: [],
    trailerType: [],
    ...appliedFilters
  };

  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={initialValues}
      enableReinitialize
    >
      {({ setFieldValue }) => (
        <Form className="booking-filter-form">
          <Field
            name="includeInternal"
            label="Include internal bookings"
            component={Switch}
          />
          <Field
            name="direction"
            label="Direction"
            placeholder="Any"
            options={directionOptions}
            component={MultiSelect}
            onBlur={selectedItems => {
              setFieldValue("direction", selectedItems);
            }}
          />
          <Field
            name="status"
            label="Status"
            placeholder="Any"
            options={statusOptions}
            component={MultiSelect}
            onBlur={selectedItems => {
              setFieldValue("status", selectedItems);
            }}
          />
          <Field
            name="haulier"
            label="Haulier"
            placeholder="Any"
            options={haulierOptions(bookings)}
            component={MultiSelect}
            onBlur={selectedItems => {
              setFieldValue("haulier", selectedItems);
            }}
          />
          <Field
            name="sendingSite"
            label="Sending Site"
            placeholder="Any"
            options={sendingSiteOptions(bookings)}
            component={MultiSelect}
            onBlur={selectedItems => {
              setFieldValue("sendingSite", selectedItems);
            }}
          />
          <Field
            name="receivingSite"
            label="Receiving Site"
            placeholder="Any"
            options={receivingSiteOptions(bookings)}
            component={MultiSelect}
            onBlur={selectedItems => {
              setFieldValue("receivingSite", selectedItems);
            }}
          />
          <Field
            name="loadType"
            label="Load Type"
            placeholder="Any"
            options={loadTypeOptions(bookings)}
            component={MultiSelect}
            onBlur={selectedItems => {
              setFieldValue("loadType", selectedItems);
            }}
          />
          <Field
            name="trailerType"
            label="Trailer Type"
            placeholder="Any"
            options={trailerTypeOptions(bookings)}
            component={MultiSelect}
            onBlur={selectedItems => {
              setFieldValue("trailerType", selectedItems);
            }}
          />
          <div className="horizontal-container">
            <Button
              type="submit"
              variant="primary"
              size="small"
              title="Apply filters"
            />
            <Button
              type="reset"
              variant="secondary"
              size="small"
              title="Reset"
              onClick={onReset}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
}
